import { push } from 'react-router-redux';
import { SubmissionError } from 'redux-form';
import { hipNew, supo } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { getConnectMoreStatusById, getJobById } from '../selectors/job';
import { messageData, transformQuestions } from './getQuotes';

export const postBunningsEnquiry = (form, basePath, ...sites) => async dispatch => {
  const selections = addUserSelections(form, ...sites.map(site => site.id));
  const questions = transformQuestions(selections);
  const addSite = addSiteEntity(questions, sites[0]);
  const formatted = messageData(addSite);

  const { data } = await hipNew.post('/api/bunnings/get-qutoes/post-job', formatted);

  if (data.errors) {
    throw new SubmissionError(data.errors);
  }

  if (data.job) {
    dispatch({ type: ActionTypes.POST_JOB_SUCCESS, payload: data.job });
    const { userSelectedAssignmentsOnly, id } = data.job;
    if (userSelectedAssignmentsOnly) {
      dispatch(push(`/${basePath}/${sites[0].key}/similar_businesses/${id}`));
    } else {
      window.location = data.job.thankYouPageLink;
    }
  }
};

export const getBunningsCategoryData = key => async dispatch => {
  const { data } = await supo.get(`/category/key/${key}`);

  if (data.errors) {
    throw new SubmissionError(data.errors);
  }

  if (data.id) {
    dispatch({ type: ActionTypes.LOAD_BUN_CATEGORY, payload: data });
  }
};

export const postDirectEnquiry = (form, basePath, ...sites) => async dispatch => {
  const selections = addUserSelections(form, ...sites.map(site => site.id));
  const questions = transformQuestions(selections);
  const addSite = addSiteEntity(questions, sites[0]);
  const formatted = messageData(addSite);

  const { data } = await hipNew.post('/api/enquire', formatted);

  if (data.errors) {
    throw new SubmissionError(data.errors);
  }

  if (data.job) {
    dispatch({ type: ActionTypes.POST_JOB_SUCCESS, payload: data.job });
    const { userSelectedAssignmentsOnly, id } = data.job;
    if (userSelectedAssignmentsOnly) {
      dispatch(push(`/${basePath}/${sites[0].key}/similar_businesses/${id}`));
    } else {
      window.location = data.job.thankYouPageLink;
    }
  }
};

const addSiteEntity = (data, site) => ({
  ...data,
  site_entity_id: site.entityId
});

const addUserSelections = (data, ...ids) => ({
  ...data,
  user_selection_site_ids: [...ids]
});

export const connectMore = (jobId, redirect = true) => async (dispatch, getState) => {
  const state = getState();

  if (getConnectMoreStatusById(state, jobId) === ActionTypes.JOB_CONNECT_MORE_REQUEST) {
    return;
  }

  dispatch({
    type: ActionTypes.JOB_CONNECT_MORE_REQUEST,
    payload: { id: jobId }
  });
  const { thankYouPageLink } = getJobById(state, jobId);
  const { data } = await hipNew.post('/api/connect-more', { job_id: jobId });
  if (data.success) {
    dispatch({
      type: ActionTypes.JOB_CONNECT_MORE_SUCCESS,
      payload: { id: jobId }
    });
    if (redirect) {
      window.location = thankYouPageLink;
    }
  } else {
    dispatch({
      type: ActionTypes.JOB_CONNECT_MORE_ERROR,
      payload: { id: jobId }
    });
  }
};

export const dontConnectMore = jobId => async (dispatch, getState) => {
  const state = getState();
  if (getConnectMoreStatusById(state, jobId) === ActionTypes.JOB_CONNECT_MORE_REQUEST) {
    return;
  }
  dispatch({
    type: ActionTypes.JOB_CONNECT_MORE_REQUEST,
    payload: { id: jobId }
  });
  const { thankYouPageLink } = getJobById(state, jobId);
  window.location = thankYouPageLink;
};
